module.exports = __webpack_public_path__ + "img/transparencia_five.4d302f7a.png";